import type { InputProps } from "antd";
import { FormInput } from "../Form";
import styles from "./styles.module.scss";

export const RegistrationInput = (props: InputProps) => (
  <FormInput {...props} className={styles["registration-input"]} />
);
